import { useState } from "react";
import { format, parseISO } from "date-fns";
import { tr } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

// Türkçe tarih seçici — tarayıcı yerine shadcn Calendar (yıl/ay açılır menülü). Değer ISO (yyyy-MM-dd).
export function DatePickerTR({ value, onChange, testid = "date-picker", placeholder = "Tarih seçin", disabled, className }) {
  const [open, setOpen] = useState(false);
  let selected;
  try { const v = value ? parseISO(String(value).slice(0, 10)) : undefined; selected = v && !isNaN(v) ? v : undefined; } catch { selected = undefined; }
  const label = selected ? format(selected, "d MMMM yyyy", { locale: tr }) : "";
  const thisYear = new Date().getFullYear();
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} disabled={disabled}
          className={cn("mt-1 flex h-10 w-full items-center gap-2 rounded-md border border-input bg-white px-3 text-left text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-brand-green disabled:opacity-50", !label && "text-slate-400", className)}>
          <CalendarIcon className="h-4 w-4 shrink-0 text-slate-400" />
          {label || placeholder}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start" data-testid={`${testid}-popover`}>
        <Calendar mode="single" locale={tr} selected={selected} defaultMonth={selected}
          captionLayout="dropdown-buttons" fromYear={1980} toYear={thisYear + 1}
          classNames={{
            caption: "flex justify-center pt-1 pb-1 relative items-center",
            caption_label: "hidden",
            caption_dropdowns: "flex items-center justify-center gap-2",
            dropdown: "cursor-pointer rounded-md border border-slate-200 bg-white px-2 py-1 text-sm font-semibold text-slate-700 focus:outline-none focus:ring-2 focus:ring-brand-green",
            vhidden: "sr-only",
          }}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
}

export default DatePickerTR;
